import { observable } from "mobx";
import CustomerRefundCandidateApprovalRejectionReason from "./customerRefundCandidateApprovalRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundationPermittedActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: CustomerRefundCandidateApprovalRejectionReason;
}
